<template>
  <div>
    <h2>Modifier un groupe</h2>
    <div class="display">
      <form action="" @submit.prevent="send()" @reset="reset()">
        <ul>
          <li>
            <label for="nomGroupe">Nom Du groupe</label>
            <input id="nomGroupe" name="nomGroupe" type="text" v-model="groupe.nom">
          </li>
          <li>
            <label for="nbrMusicien">Nombre de musicien <span class="optional"> - optionnel</span></label>
            <input id="nbrMusicien" name="nbrMusicien" type="number" v-model="groupe.nbr_musicien">
          </li>
          <li>
            <fieldset>
              <legend>Genre de musique</legend>
              <ul class="genre">
                <li v-for="genre in genres" :key="genre.id">
                  <input type="checkbox" :id="genre.nom" :value="genre.nom" v-model="groupe.genre">
                  <label :for="genre.nom">{{ genre.nom }}</label>
                </li>
              </ul>
            </fieldset>
          </li>
          <li>
            <label for="personneContact">Personne de contact</label>
            <input id="personneContact" name="personneContact" type="text" v-model="groupe.contact">
          </li>
          <li>
            <label for="mail">E-Mail <span class="optional"> - optionnel</span></label>
            <input id="mail" name="mail" type="email" v-model="groupe.mail">
          </li>
          <li>
            <label for="tel">Numero de téléphone <span class="optional"> - optionnel</span></label>
            <input id="tel" name="tel" type="tel" v-model="groupe.tel">
          </li>
          <li>
            <label for="siteWeb">Site internet <span class="optional"> - optionnel</span></label>
            <input id="siteWeb" name="siteWeb" type="url" v-model="groupe.website">
          </li>
          <li>
            <label for="lien">Lien <span class="optional"> - optionnel</span></label>
            <input id="lien" name="lien" type="url" v-model="groupe.link">
          </li>
          <li>
            <button type="submit">Mettre à jour le groupe</button>
            <button type="reset">Annuler</button>
          </li>
        </ul>
      </form>
    </div>
  </div>
</template>

<script>
import {settings} from '../../assets/settings'

export default {
  name: 'UpdateGroupe',
  props: ['name'],
  data () {
    return {
      genres: [],
      groupe: {
        nom: '',
        nbr_musicien: '',
        contact: '',
        mail: '',
        tel: '',
        website: '',
        link: '',
        genre: []
      }
    }
  },
  methods: {
    getGenres () {
      this.$http.get(settings.apiUrl + '/musickind/' + this.$parent.store.getToken()).then((response) => {
        this.genres = response.body.payload
      })
    },
    getGroupe () {
      this.$http.get(settings.apiUrl + '/group/' + this.name + '/' + this.$parent.store.getToken()).then((response) => {
        this.groupe = response.body.payload
      })
    },
    send () {
      let error = ''
      if (this.groupe.nom.length <= 0) {
        error += '\nEntrez un nom de groupe correct'
      }
      if (this.groupe.genre.length <= 0) {
        error += '\nSélectionnez au moins un genre'
      }
      if (this.groupe.contact.length <= 0) {
        error += '\nEntrez un nom de groupe correct'
      }
      if (error.length !== 0) {
        alert(error)
        return
      }
      // change to update
      this.$http.put(settings.apiUrl + '/group/' + this.name + '/' + this.$parent.store.getToken(), {data: JSON.stringify(this.groupe)}).then((response) => {
        if (response.body.success === false) {
          alert('error')
        } else {
          this.reset()
        }
      })
    },
    reset () {
      window.location.replace('/#/groupes')
    }
  },
  mounted () {
    this.getGenres()
    this.getGroupe()
  }
}
</script>

<style scoped lang="scss">
  .display {
    width: calc(100% - 30px);
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    height: calc(100vh - 210px);
    padding: 15px;
    margin-top: 20px;
    overflow-y: scroll;
    form {
      max-width: 500px;
      margin:auto;
    }
    ul:not(.genre) {
      list-style-type: none;
      padding: 0;
      margin: 0;
      label, input {
        display: block;
      }
      input {
        border: none;
        background-color: #f4f4f4;
        padding: 5px;
        font-size: 20px;
      }
      label {
        padding-bottom: 3px;
        .optional {
          font-size: 15px;
          color: #5d5d5d;
        }
      }
      li {
        padding: 10px;
      }
      button {
        padding: 10px;
        font-size: 20px;
        cursor: pointer;
        border: none;
        color: #fff;
        background-color: #175676;
      }
      button[type='reset'] {
        color: #175676;
        background-color: #f4f4f4;
      }
    }
    ul.genre {
      list-style-type: none;
      padding: 10px;
      input, label {
        display: inline;
      }
      li {
        display: inline;
        label {
          display: inline-block;
          background-color: rgba(255, 255, 255, .9);
          border: 2px solid #175676;
          color: #175676;
          border-radius: 25px;
          white-space: nowrap;
          margin: 3px 0px;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
          transition: all .2s;
          padding: 8px 12px;
          cursor: pointer;
        }
        input[type='checkbox']:checked + label {
          border: 2px solid #175676;
          background-color: #175676;
          color: #fff;
          transition: all .2s;
        }
        input[type="checkbox"] {
          display: absolute;
          position: absolute;
          opacity: 0;
        }
        input[type="checkbox"]:focus + label {
          border: 2px solid #175676;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Page/UpdateGroupe.vue